import React from 'react';
import Header from '../components/Header/Header';
import ExpressTrackerLayout from '../layouts/ExpressTrackerLayout';

const ExpressTrackerPage = () => {
  return (
    <>
      <Header />
      <ExpressTrackerLayout />
    </>
  );
};

export default ExpressTrackerPage;
